import { useEffect } from 'react';
import { useAppSelector } from 'store';

import type { BroadcastTopics } from 'services/wsService';

export const useSocketOn = <Data>(
  topic: keyof typeof BroadcastTopics | (string & {}),
  callback: (data: Data) => void,
) => {
  const socket = useAppSelector((state) => state.socket);

  useEffect(() => {
    socket.client?.on(topic, callback);
    return () => {
      socket.client?.off(topic, callback);
    };
  }, [socket, topic, callback]);
};
